<template>
  <div>
    <div class="headline">
      <!--<img src="../../assets/dog-profile.jpeg" />-->
      <h1>Profil</h1>
    </div>
    <p v-if="profile.name">
      <strong>Name:</strong> {{ profile.name }}
    </p>
    <p><router-link to="/account/changePassword" tag="button" class="btn btn-info">Passwort ändern</router-link></p>
  </div>
</template>

<style lang="scss" scoped>
.headline {
  margin-top: 1em;
  display: flex;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "account",
  computed: mapState({ profile: state => state.user.profile })
};
</script>
